<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>运营 / 学校管理</span>
      </div>
      <div class="search-container">
        <el-row
          class="search-row"
          style="margin-left: 0; margin-right: 0"
          :gutter="24"
        >
          <el-col :span="4">
            <el-select v-model="upDepart" placeholder="上级机构" clearable>
              <el-option
                v-for="item in departments"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select v-model="school" placeholder="学段" clearable>
              <el-option
                v-for="item in schools"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select v-model="type" placeholder="办学性质" clearable>
              <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model.trim="name"
              placeholder="学校名称"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="4">
            <el-select v-model="available" placeholder="学校状态" clearable>
              <el-option
                v-for="item in availables"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4" style="text-align: center">
            <el-button type="primary" size="medium" @click="initSchool(1)"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="table-container scroll">
        <el-row>
          <el-col :span="24">
            <el-button
              type="primary"
              size="medium"
              @click="handleAdd"
              :disabled="isCityArea||$regional.disableCRUD"
              >添加学校</el-button
            >
            <el-button
              type="primary"
              plain
              size="medium"
              @click="handleImport"
              :disabled="isCityArea||$regional.disableCRUD"
              >导入</el-button
            >
            <el-button type="primary" plain size="medium" @click="handleExport"
              >导出</el-button
            >
          </el-col>
        </el-row>
        <el-row class="table">
          <el-col :span="24">
            <el-table
              :data="pageData.t2"
              size="medium"
              :row-class-name="isRowAailable"
            >
              <el-table-column
                prop="name"
                min-width="90"
                label="学校名称"
              ></el-table-column>
              <el-table-column
                prop="creditCode"
                max-width="80"
                label="信用代码"
              ></el-table-column>
              <el-table-column
                prop="institution.name"
                max-width="25"
                label="上级机构"
              ></el-table-column>
              <el-table-column label="所属学段" max-width="10">
                <template slot-scope="scope">
                  <span>{{
                    (_.filter(schoolModes, { value: scope.row.schoolStage }) &&
                      _.filter(schoolModes, { value: scope.row.schoolStage })
                        .length > 0 &&
                      _.filter(schoolModes, { value: scope.row.schoolStage })[0]
                        .name) ||
                    ''
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="办学模式" max-width="10">
                <template slot-scope="scope">
                  <span>{{
                    (_.filter(banxues, { value: scope.row.schoolMode }) &&
                      _.filter(banxues, { value: scope.row.schoolMode })
                        .length > 0 &&
                      _.filter(banxues, { value: scope.row.schoolMode })[0]
                        .name) ||
                    '-'
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="办学性质" max-width="10">
                <template slot-scope="scope">
                  <span>{{
                    _.filter(types, { value: scope.row.schoolType })[0].name
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="adminAccount"
                max-width="30"
                label="管理账号"
              ></el-table-column>
              <el-table-column min-width="175" fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :disabled="!scope.row.available || isCityArea || $regional.disableCRUD"
                    @click="schoolManage(scope.row)"
                    >管理</el-button
                  >
                  <el-button
                    type="text"
                    :disabled="!scope.row.available || isCityArea || $regional.disableCRUD"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    :disabled="!scope.row.available || isCityArea"
                    @click="handleResetPass(scope.$index, scope.row)"
                    >重置密码</el-button
                  >
                  <el-button
                    type="text"
                    @click="handleDisable(scope.$index, scope.row)"
                    :disabled="isCityArea || $regional.disableCRUD"
                    >{{ scope.row.available ? '停用' : '启用' }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row class="zyyj-pagination-row">
          <el-col :span="24">
            <el-pagination
              :total="pageData.t1"
              :current-page.sync="page"
              :page-sizes="[20, 50, 100]"
              :page-size.sync="size"
              background
              layout="total, sizes, prev, pager, next"
              @current-change="initSchool"
              @size-change="handleSizeChange"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>

    <school-edit-box
      :visible.sync="editorVisible"
      :identify="schoolInfo"
      @edit-result="initSchool(page)"
    ></school-edit-box>

    <excel-importer-box
      topic="学校"
      action="/acc/schools/import"
      template="/acc/schools/templates"
      errorUrl="/acc/schools/export/fail"
      type="学校"
      :visible.sync="importDialogVisible"
      @import-result="initSchool(page)"
    >
      <template slot="if-failure">
        <el-table-column
          prop="objectName"
          label="学校名称"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="rowNum"
          label="所在行"
          width="100"
        ></el-table-column>
        <el-table-column prop="errorMessageList" label="导入失败原因">
          <template slot-scope="scope">
            <span v-for="(msg, index) in scope.row.errorMessageList" :key="msg">
              <span>{{ msg }}</span>
              <span v-if="index !== scope.row.errorMessageList.length - 1"
                >、</span
              >
            </span>
          </template>
        </el-table-column>
      </template>
    </excel-importer-box>
    <school-manage-dialog
      :dialogShow.sync="dialogShow"
      :dialogSchoolStage="dialogSchoolStage"
      :schoolId="schoolId"
    ></school-manage-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import SchoolEditor from '@/components/admin/operate/SchoolEditor'
import ExcelImporterBox from '@/components/common/ExcelImporterBox'
import SchoolManageDialog from '@/components/admin/operate/SchoolManageDialog'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'school-edit-box': SchoolEditor,
    'excel-importer-box': ExcelImporterBox,
    SchoolManageDialog
  },

  data() {
    return {
      pageData: {},
      size: 0,
      page: 1,
      editorVisible: false,
      schoolInfo: {},
      upDepart: '',
      departments: [],
      school: '',
      available: '',
      availables: [
        {
          name: '正常',
          value: true
        },
        {
          name: '停用',
          value: false
        }
      ],
      schoolModes: [
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        }
      ],
      schools: [
        {
          name: '小学',
          value: 1
        },
        {
          name: '初中',
          value: 2
        },
        {
          name: '高中',
          value: 3
        }
      ],
      banxues: [
        {
          name: '九年一贯制',
          value: 4,
          disabled: false
        },
        {
          name: '十二年一贯制',
          value: 5,
          disabled: false
        },
        {
          name: '完全中学',
          value: 6,
          disabled: false
        },
        {
          name: '教学点',
          value: 7,
          disabled: false
        },
        {
          name: '职教中心',
          value: 8,
          disabled: false
        }
      ],
      type: '',
      types: [
        {
          name: '公办',
          value: 1
        },
        {
          name: '民办',
          value: 2
        }
      ],
      name: '',
      importDialogVisible: false,
      dialogShow: false,
      dialogSchoolStage: null,
      schoolId: null
    }
  },

  watch: {},

  computed: {
    ...mapState(['user']),
    isCityArea() {
      return this.user.level === 1 || this.user.level === 2
    },
    _() {
      return _
    }
  },

  mounted() {
    this.initDepart()
    this.initSchool()
  },

  methods: {
    schoolManage(row) {
      this.schoolId = row.id
      this.dialogSchoolStage = row.schoolStage
      this.dialogShow = true
    },
    initDepart() {
      // 获取上级机构
      this.$xhrGet(`/acc/institutions`, { isSelf: true }).then(rs => {
        this.departments = rs.data
      })
    },
    initSchool(page) {
      if (page) {
        this.page = page
      }
      let queryParam = {
        institutionId: this.upDepart,
        schoolStage: this.school,
        type: this.type,
        name: this.name,
        available: this.available,
        size: this.size ? this.size : 20,
        page: this.page
      }
      this.$xhrGet(`/acc/schools`, queryParam).then(rs => {
        this.pageData = rs.data
      })
    },

    handleSizeChange(val) {
      this.size = val
      this.page = 1
      let queryParam = {
        institutionId: this.upDepart,
        schoolStage: this.school,
        type: this.type,
        name: this.name,
        available: this.available,
        size: this.size,
        page: this.page
      }
      this.$xhrGet(`/acc/schools`, queryParam).then(rs => {
        this.pageData = rs.data
      })
    },

    handleAdd() {
      this.editorVisible = true
      this.schoolInfo = {}
    },

    handleImport() {
      this.importDialogVisible = true
    },

    handleExport() {
      this.$fetchFile(`/acc/schools/export`, { name: '学校表' })
    },

    handleEdit(index, row) {
      this.editorVisible = true
      this.schoolInfo = row
    },

    handleResetPass(index, row) {
      this.$xhrPatch(`/acc/school/password/reset`, { schoolId: row.id }).then(
        rs => {
          if (rs.code === 'SUCCESS') {
            this.$message.success('重置密码成功')
          }
        }
      )
    },

    handleDisable(index, row) {
      this.$xhrPatch(`/acc/schools/${row.id}`, {
        available: !row.available
      }).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initSchool()
        } else if (rs.code === 403) {
          this.$message.success('')
        }
      })
    },

    isRowAailable({ row, rowIndex }) {
      return 'zyyj-row-available-' + row.available
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.search-container {
  width: calc(100% - 80px);
  height: 76px;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.search-row {
  height: 100%;
  padding: 20px;
  background: #f9f9f9;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 264px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
/deep/ .el-input__inner {
  height: 36px;
}
/deep/ .el-button--primary.is-plain {
  background: transparent;
}
.el-button--primary.is-plain:hover,
.el-button--primary.is-plain:focus {
  color: var(--theme-color);
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/operate/SchoolManage.vue